<script setup lang="ts">
import { ElTag } from 'element-plus'
import { computed } from 'vue'
import { type HistoryEvent } from './PaymentList.vue'

const props = defineProps<{
  invoiceId: number
  status?: string
  historyEvents: HistoryEvent[]
}>()

type ElTagType = InstanceType<typeof ElTag>['type']

const getStatusTagType = (status: string | null): ElTagType => {
  switch (status) {
    case 'paid':
    case 'completed':
      return 'success'
    case 'pending':
    case 'open':
      return 'warning'
    case 'failed':
      return 'danger'
    default:
      return 'info'
  }
}

const formattedHistory = computed(() => props.historyEvents ?? [])

const formatTimestamp = (timestamp: string | null | undefined) => {
  if (!timestamp) return '-'
  const date = new Date(timestamp)
  if (Number.isNaN(date.getTime())) return '-'

  return new Intl.DateTimeFormat('sv-SE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).format(date)
}
</script>
<template>
  <el-popover placement="right" trigger="hover" :width="250">
    <template #default>
      <el-timeline v-if="formattedHistory.length">
        <el-timeline-item
          v-for="(ev, i) in formattedHistory"
          :key="i"
          :type="getStatusTagType(ev.status)"
          :timestamp="formatTimestamp(ev.timestamp)"
        >
          {{ ev.message }}
        </el-timeline-item>
      </el-timeline>
    </template>

    <template #reference>
      <el-tag :type="getStatusTagType(status)">
        {{ status ?? '-' }}
      </el-tag>
    </template>
  </el-popover>
</template>
